import React from "react";
import styled from "styled-components";
import { Option, SmartAccommodation } from "./SmartAccommodation";
import { StyledSelector } from "../styles";
import { InventoryEntry } from "../../../../../lib/model";

export const StyledSpinner = styled.i`
  .fa-spin-custom,
  .glyphicon-spin {
    animation: spin 1000ms infinite linear;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
`;

type AccommodationSelectorProps = {
  hasVirtualInventories?: boolean;
  locale: string;
  inventoryTicker: string;
  propertyTicker: string;
  inventories?: InventoryEntry[];
  disabled?: boolean;
  options: { value: string; label: string }[];
  selectedOption?: { value: string; label: string };
  onChange: (value: Option) => void;
};

function AccommodationSelectorWrapper(props: AccommodationSelectorProps) {
  if (props.hasVirtualInventories === undefined) {
    return (
      <div className="mb-3">
        <StyledSpinner className="fa fa-spinner fa-spin" />
      </div>
    );
  }
  if (props.hasVirtualInventories) {
    return (
      <SmartAccommodation
        locale={props.locale}
        ticker={props.inventoryTicker}
        propertyTicker={props.propertyTicker}
        onChange={props.onChange}
        inventories={props.inventories}
      />
    );
  }
  return (
    <StyledSelector
      isDisabled={props.disabled}
      options={props.options}
      value={props.selectedOption}
      onChange={props.onChange}
    />
  );
}

export default React.memo(AccommodationSelectorWrapper);
